<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-23 20:25:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refundlist/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-22 10:48:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refundlist/index.vue
-->
<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-21 18:05:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/refund/refundlist/index.vue
-->
<template>
  <div class="">
    <title-bar-back :title="'售后列表'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="!getAfterSaleList.hasNextPage"
        finished-text="我已经到底啦～"
        @load="onLoad"
      >
        <div
          v-for="(item, index) in getAfterSaleList.rows"
          :key="index"
          class="re_li_con"
        >
          <refund-list-header :item="item" />
          <div v-for="(i, index2) in item.userAfterSaleItemsVOS" :key="index2">
            <order-product-list
              v-if="!i.isGift"
              :listIndex="index2"
              :pageShow="false"
              :item="i"
            />
            <!-- 赠品 -->
            <div v-if="i.isGift" class="free_product_list">
              <free-product
                :showBor="false"
                :freeProduct="i"
                :orderSn="item.orderSn"
              />
            </div>
          </div>

          <refund-list-btn
            :id="item.id"
            :showDelete="
              item.status === -32 ||
                item.status === -31 ||
                item.status === -30 ||
                item.status === -1 ||
                item.status === 34 ||
                item.status === 35
            "
            @deleteAfter="deleteAfter"
            @goRefundDetail="goRefundDetail"
          />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import RefundListHeader from "./components/RefundListHeader";
import OrderProductList from "../../list/components/OrderProductList";
import RefundListBtn from "./components/RefundListBtn";
import FreeProduct from "../../detail/components/FreeProduct";
export default {
  name: "RefundrList",
  components: {
    TitleBarBack,
    RefundListHeader,
    OrderProductList,
    RefundListBtn,
    FreeProduct
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    getAfterSaleList() {
      return this.$store.getters.getAfterSaleList;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    back() {
      this.$router.push("/mine");
    },
    // 获取数据
    getData(pageNo = 1, pageSize = 20) {
      // getAfterSaleList
      const params = {
        pageNo,
        pageSize
      };
      this.$store
        .dispatch("order/getAfterSaleList", { params })
        .then(() => {})
        .catch(() => {});
    },
    // 删除售后 deleteAfterSale
    deleteData(id) {
      this.$store
        .dispatch("order/deleteAfterSale", { params: { id } })
        .then(() => {
          this.getData();
        })
        .catch(() => {});
    },
    // 刷新
    onRefresh() {
      this.getData();
    },
    onLoad() {
      // console.log("上拉进行中");
      this.loadings = false;
      if (
        this.getAfterSaleList.hasNextPage &&
        this.getAfterSaleList.pageNo <= this.getAfterSaleList.pageCount
      ) {
        this.loadings = true;
        const pageIndex = this.getAfterSaleList.pageNo + 1;
        this.getData(pageIndex);
        // console.log("上拉完毕");
      }
    },
    goRefundDetail(id) {
      this.$router.push({
        path: "/order/refund/refunddetail",
        query: {
          id
        }
      });
    },
    deleteAfter(id) {
      this.$dialog
        .confirm({
          message: "您确定要删除该条记录吗？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          // 确认收货
          this.deleteData(id);
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.re_li_con {
  background: #fff;
  margin-top: 12px;
  padding: 0 12px;
  ::v-deep .order_product {
    padding-right: 0;
  }
  .free_product_list {
    background: #fff;
    margin: 0 12px;
  }
}
</style>
